module.exports = __webpack_public_path__ + "assets/168bdac9a7fb921c7de399412e83daf3.png";